import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	moreButtonIconLabel: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.more-button-icon-label',
		defaultMessage: 'more options',
		description: 'button icon label for dropdown menu to edit, copy and delete a priority scheme',
	},
	actionsTooltip: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.actions-tooltip',
		defaultMessage: 'More actions for selected priority scheme',
		description: 'Tooltip content to describe actions available for a priority scheme',
	},
	isLockedTooltip: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.is-locked-tooltip',
		defaultMessage:
			'We’re updating a priority scheme and you can edit priority schemes after we’re done.',
		description: 'tooltip content to inform the user that this is currently locked',
	},
});
